import { z } from "zod";

export const hazmatClassSchema = z.object({
	id: z.number(),
	name: z.string(),
	code: z.string(),
});
export const hazmatGroupSchema = z.object({
	id: z.number(),
	name: z.string(),
	code: z.string(),
	displayCode: z.string().optional(),
});

export type HazmatClass = z.infer<typeof hazmatClassSchema>;
export type HazmatGroup = z.infer<typeof hazmatGroupSchema>;
